export const isDebugUrl = () => {
  return location.href.includes('~~debug~~');
};
